import React from 'react'
import { CollectionType } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { CollectionTypeHelper, enabledCollectionTypes } from 'model'

interface CollectionTypeSelectboxProps extends Omit<SelectboxProps<CollectionType, CollectionType>, 'optionKeys'> {
  enabledCollectionTypes?: CollectionType[]
}

const enabledCollections = enabledCollectionTypes.filter(c => c !== CollectionType.ALL_OR_NOTHING_X)

const CollectionTypeSelectbox = React.forwardRef((props: CollectionTypeSelectboxProps, ref: React.Ref<Selectbox>) => {
  return (
    <Selectbox
      ref={ref}
      optionKeys={props.enabledCollectionTypes || enabledCollections}
      getOptionText={CollectionTypeHelper.getName}
      {...props}
    />
  )
})
export const CollectionTypeSelectboxField = Field(CollectionTypeSelectbox)
